import { IconLock } from "components/icons/IconLock";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import React from "react";
import { useTranslation } from "react-i18next";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { CardContextLink } from "views/knowledge/components/card/CardContextLink";

///
export const CardChannelLink: React.FC = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");

    return (
        <>
            {
                pub.channel?.name &&
                <CardContextLink
                    publicationId={pub.publicationId}
                    to={KnowledgePaths.FeedChannel(pub.channel.id)}
                >
                    <MprcFeedTypography variant="classification">
                        {pub.channel.name}
                        &nbsp;&nbsp;
                        {pub.isPrivate &&
                            <span title={t("Feed.Card.Common.PrivateTooltip")}>
                                <IconLock locked lockedColor="muted" />
                            </span>
                        }
                    </MprcFeedTypography>
                </CardContextLink>
            }
        </>
    );
};
